import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { ConfigProvider, Dropdown } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import classes from "./SideNavbar.module.css";
import userimg from "../../Assests/Images/userimg.png";
import ChangePasswordModal from "../../Modals/ChangePasswordModal";
import {
  UpdateDeviceID,
  UpdateMeterID,
  handleloading,
} from "../../Store/Redux/Reducers/Dashboardreducers";
import { LogoutApi } from "../../Services/ApiServices";
import {
  CatchMessage,
  CheckUserType,
  HandleDeviceId,
  HandleMeterId,
  JSONtoformdata,
} from "../../Shared/Methods";
import { setCookie } from "../../Store/Storage/Cookies";
import { UpdateLoginDate } from "../../Store/Redux/Reducers/Authreducers";
import CommonModal from "../../Modals/CommonModal";
import Allertmodal from "../../Modals/AllertModal";
import notifyimg from "../../Assests/Images/notification.png";
import settingsimg from "../../Assests/Images/settings.png";
import mailImg from "../../Assests/Images/email.png";
import SettingsModal from "../../Modals/SettingsModal";
import Commondevicedropdown from "../../Components/Header/CommonDeviceDropdown";
import LogoutconfirmationModal from "../../Modals/LogoutConfirmationModal";
import instance from "../../Services/Axios";
import logouticon from "../../Assests/Icons/logout.png";
import passwordicon from "../../Assests/Icons/reset-password.png";
import profileimg from "../../Assests/Icons/profile.png";

interface props {
  setopen: Dispatch<SetStateAction<boolean>>;
  open: boolean;
  handleDashboardData: (id1: any, id2: any) => void;
}

function Header({ setopen, open, handleDashboardData }: props) {
  const [showPWModal, setShowPWModal] = useState(false);
  const { LoginData } = useSelector((state: any) => state.Auth);
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const [showLogout, setshowLogout] = useState(false);
  const [Issettings, setIssettings] = useState(false);
  const [IsMailOPen, setIsMailOpen] = useState(false);
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { AlertData } = useSelector((state: any) => state.Dashboard);
  const renderondeviceID = HandleDeviceId();
  const renderonmeterID = HandleMeterId();

  // useEffect(() => {
  //   if (
  //     LoginData !== null &&
  //     renderondeviceID?.deviceId &&
  //     renderonmeterID?.meter_id &&
  //     pathname !== "/dashboard"
  //   ) {
  //     handleDashboardData(renderondeviceID, renderonmeterID);
  //   }
  // }, [LoginData, renderondeviceID?.deviceId, renderonmeterID?.meter_id]);

  const items: any = [
    {
      key: 3,
      label: "Profile",
      icon: <img src={profileimg} alt="logouticon" style={{ width: "16px" }} />,

      onClick: () => {
        navigate("/user_profile");
      },
    },
    CheckUserType()
      ? {
          key: 1,
          label: "Change Password",
          icon: (
            <img
              src={passwordicon}
              alt="logouticon"
              style={{ width: "17px" }}
            />
          ),

          onClick: () => {
            setShowPWModal(true);
          },
        }
      : null,
    {
      key: 2,
      label: "Logout",
      icon: <img src={logouticon} alt="logouticon" style={{ width: "19px" }} />,
      onClick: () => {
        setshowLogout(true);
      },
    },
  ];

  const getHeading = () => {
    if (pathname?.includes("motordashboard")) {
      return { heading: "Motor Dashboard" };
    } else if (pathname.includes("dashboard")) {
      return {
        heading: "Dashboard",
      };
    } else if (pathname.includes("device")) {
      return {
        heading: "Device",
      };
    } else if (pathname.includes("reports")) {
      return {
        heading: "Reports",
      };
    } else if (pathname === "/user" || pathname === "/user/viewuser") {
      return {
        heading: "User",
      };
    } else if (pathname.includes("subscription")) {
      return {
        heading: "Subscription",
      };
    } else if (pathname === "/user_profile") {
      return {
        heading: "Profile",
      };
    } else if (pathname === "/mail_settings") {
      return {
        heading: "Mail Settings",
      };
    }
  };

  const handleLogout = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
    };

    LogoutApi(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res?.data?.status === 1) {
          navigate("/");
          setshowLogout(false);
          instance.defaults.baseURL = window.appConfig.ROOT_URL;
          window.location.reload();

          HandleSessionItems();
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const showAlertModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setIssettings(false);
    setshowLogout(false);
    setShowPWModal(false);
  };

  const HandleSessionItems = () => {
    sessionStorage.setItem("DeviceCode", "");
    sessionStorage.setItem("MeterCode", "");
    setCookie("MconnectEnergyLoginData", null, null);
    dispatch(UpdateLoginDate(null));
    dispatch(UpdateMeterID(""));
    dispatch(UpdateDeviceID(""));
  };

  return (
    <>
      <CommonModal
        open={isModalOpen}
        closable={false}
        onCancel={handleCancel}
        width={300}
        Children={<Allertmodal onCancel={handleCancel} />}
      />

      {Issettings ? (
        <SettingsModal
          onCancel={handleCancel}
          open={Issettings}
          closable={false}
        />
      ) : null}

      {showLogout ? (
        <LogoutconfirmationModal
          handleSuccess={() => {
            handleLogout();
          }}
          open={showLogout}
          closable={!showLogout}
          onCancel={handleCancel}
        />
      ) : null}

      {showPWModal ? (
        <ChangePasswordModal
          open={showPWModal}
          closable={!showPWModal}
          onCancel={handleCancel}
        />
      ) : null}
      <div className={classes.header_inline_container_div}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 17px",
            margin: "0 10px",
            gap: "10px",
            flexFlow: "wrap",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "center",
              flexFlow: "wrap",
            }}
          >
            <h5 style={{ fontWeight: 600, margin: "0" }}>
              {getHeading()?.heading}
            </h5>
            {(pathname.includes("dashboard") ||
              pathname.includes("reports")) && (
              <Commondevicedropdown handleDashboardData={handleDashboardData} />
            )}
          </div>
          <div className={classes.header_container}>
            {/* <div className={classes.hamburger_menu_container}>
            <Hamburger toggled={open} size={20} toggle={() => setopen(!open)} />
          </div> */}

            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src={mailImg}
                  alt="settings"
                  style={{ width: "27px", marginRight: 8 }}
                  onClick={() => {
                    navigate("/mail_settings");
                  }}
                />
                <div
                  style={{ position: "relative", cursor: "pointer" }}
                  onClick={(e) => {
                    // if (
                    //   AlertData?.hv_alert ||
                    //   AlertData?.lv_alert ||
                    //   AlertData?.pf_alert ||
                    //   AlertData?.power_fail
                    // ) {
                    showAlertModal();
                    // }
                  }}
                >
                  <img
                    className={classes.notifyIcon}
                    src={notifyimg}
                    style={{ width: "25px", marginRight: 8, marginBottom: 2 }}
                    alt="notifyimg"
                  />
                  {AlertData?.pf_alert ||
                  AlertData?.lv_alert ||
                  AlertData?.hv_alert ||
                  AlertData?.power_fail ||
                  AlertData?.eb_power === 0 ||
                  AlertData?.communication_fail ? (
                    <p className={`blinkAnime ${classes.alert_count_bg}`}>
                      {AlertData?.pf_alert +
                        AlertData?.lv_alert +
                        AlertData?.hv_alert +
                        AlertData?.power_fail +
                        AlertData?.communication_fail +
                        (AlertData?.eb_power === 0 ? 1 : 0)}
                    </p>
                  ) : null}
                </div>

                <img
                  src={settingsimg}
                  alt="settings"
                  style={{ width: "25px" }}
                  onClick={() => {
                    setIssettings(true);
                  }}
                />
              </div>

              <ConfigProvider
                theme={{
                  components: {
                    Dropdown: {
                      zIndexPopup: 105089776897,
                    },
                  },
                }}
              >
                <Dropdown menu={{ items }} placement="topLeft">
                  <div className={classes.header_container_profile_div}>
                    &nbsp;
                    <p style={{ cursor: "pointer" }}>{LoginData?.userName}</p>
                    &nbsp; &nbsp;
                    <img src={userimg} alt="userimg" />
                  </div>
                </Dropdown>
              </ConfigProvider>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
